var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskReviewedOcr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91683 1.41667H12.8335C13.1835 1.41667 13.4168 1.65 13.4168 2V17.1667C13.4168 17.5167 13.1835 17.75 12.8335 17.75H1.16683C0.816829 17.75 0.583496 17.5167 0.583496 17.1667V2C0.583496 1.65 0.816829 1.41667 1.16683 1.41667H4.0835V0.833333C4.0835 0.483333 4.31683 0.25 4.66683 0.25H9.3335C9.6835 0.25 9.91683 0.483333 9.91683 0.833333V1.41667ZM8.75016 1.41667H5.25016V2.58333H8.75016V1.41667ZM12.2502 16.5833H1.75016V2.58333H4.0835V3.16667C4.0835 3.51667 4.31683 3.75 4.66683 3.75H9.3335C9.6835 3.75 9.91683 3.51667 9.91683 3.16667V2.58333H12.2502V16.5833ZM10.9087 8.61081C11.142 8.37747 11.142 8.02747 10.9087 7.79414C10.6753 7.56081 10.3253 7.56081 10.092 7.79414L5.83366 12.0525L3.90866 10.1275C3.67533 9.89414 3.32533 9.89414 3.09199 10.1275C2.85866 10.3608 2.85866 10.7108 3.09199 10.9441L5.42533 13.2775C5.54199 13.3941 5.65866 13.4525 5.83366 13.4525C6.00866 13.4525 6.12533 13.3941 6.24199 13.2775L10.9087 8.61081Z",
    fill: "#009A44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskReviewedOcr);
export default __webpack_public_path__ + "static/media/task-reviewed-ocr.59990f184579053b44f7d90e18f68af7.svg";
export { ForwardRef as ReactComponent };